import '../sass/styles.scss';
import 'slick-carousel/slick/slick.js';
import 'dropkickjs/dist/dropkick.js';
import AOS from 'aos/dist/aos.js';
import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm';
import swal from 'sweetalert/dist/sweetalert.min.js';
import 'parsleyjs/dist/parsley.js';



$ = jQuery;

$('#cotizador').parsley();

AOS.init({
    // once: true,
});

$('.slider').on('afterChange', function(event, slick, currentSlide) {
    AOS.refresh();
});


$(".slider").slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    adaptiveHeight: true,
    pauseOnHover: false
});


$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.slider-nav',
    infinite: true
});

$('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    asNavFor: '.slider-for',
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    infinite: true,
    draggable: false,           // sin drag con mouse
    swipe: false,               // sin swipe en touch
    touchMove: false,           // ignora touchmove
    swipeToSlide: false,        // por si acaso
    responsive: [
        {
            breakpoint: 1600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
          },
        {
            breakpoint: 1440,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
    ]
});

$(".slider-specs .left").click( () => {
    $(".slider-for").slick('slickPrev');
});

$(".slider-specs .right").click( () => {
    $(".slider-for").slick('slickNext');
});


const navigator = document.querySelector('nav');
const navBtn = document.querySelector('.nav-btn');
const closeNav = document.querySelector('.close-menu');
const out = document.querySelector('main');


navBtn.addEventListener('click', function(){
    navigator.classList.add('show');
    out.classList.add('shadow');
});

closeNav.addEventListener('click', function(){
    navigator.classList.remove('show');
    out.classList.remove('shadow');
})

out.addEventListener('click', function(){
    navigator.classList.remove('show');
    out.classList.remove('shadow');
});



Fancybox.bind('.slider-for .slick-slide:not(.slick-cloned) [data-fancybox="gallery"]', {
    groupAll: false,
});
  